import { Box, Modal } from '@mui/material';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import ButtonCloseModal from '@/components/ui/Button/ButtonCloseModal';
import { BaseInputPassword } from '@/components/ui/Input/BaseInputPassword';
import usePatch from '@/hooks/usePatch';
import ModalStyle from '@/constants/ModalStyle';

const schema = yup.object().shape({
	password: yup.string().required('Gjeldende passord is a required field'),
	newpassword: yup.string().required('Nytt passord is a required field').min(8, ''),
	confirmpassword: yup.string().required('Bekreft passord is a required field').oneOf([yup.ref('newpassword'), null], 'Passwords must match'),
});

export default function ChangePassword(props) {
	const { open, onClose } = props;

	const {
		handleSubmit,
		control,
		reset,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
		defaultValues: {},
	});

	const handleClose = () => {
		reset();
		onClose();
	};

	const { mutate: changePassword } = usePatch({
		url: `api/auth/change-password`,
		method: 'post',
		callback: async (res) => {
			if (res.status === 200 && res.data) {
				toast.success(res.data?.message || 'Password updated successfully')
				handleClose()
			}
		},
	});

	const onSubmit = async(data) => {
		await changePassword({ old_password: data.password, new_password: data.newpassword  });
	};

	return (
		<Modal open={open} onClose={handleClose} aria-labelledby='modal-notes' aria-describedby='modal-notes' className='w-full'>
			<Box sx={{ ...ModalStyle, top: '25%' }} className='flex flex-col gap-4 w-[90%] md:w-[460px]'>
				<span className='text-2xl modal-title'>Endre passord</span>
				<ButtonCloseModal onClose={handleClose} />

				<hr />

				<form onSubmit={handleSubmit(onSubmit)} className='flex flex-col w-full gap-4'>
					<BaseInputPassword name='password' label='Gjeldende passord' control={control} errors={errors} />
					<BaseInputPassword name='newpassword' label='Nytt passord' control={control} errors={errors} />
					<BaseInputPassword name='confirmpassword' label='Bekreft passord' control={control} errors={errors} />

					<hr />

					<div className='flex gap-4 ml-auto'>
						<button className='px-3 py-2 text-white rounded-md btn bg-primary' type='submit'>
							Oppdater
						</button>
					</div>
				</form>
			</Box>
		</Modal>
	);
}
